import { useRef } from 'react';
import body from '../../assets/nedry/body.png';
import head from '../../assets/nedry/head.png';
import hand from '../../assets/nedry/hand.png';
import ahahah from '../../assets/nedry/ahahah.mp3';
import classes from './Nedry.module.css';

// Jean-Louis / Nedry easter egg, ported from legacy bo_jean_louis.jsp: the Jurassic Park
// "Ah ah ah — you didn't say the magic word!" finger-wagging guy, shown when an action is
// not allowed. Click him to hear the original ahahah.mp3.
export function Nedry() {
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const play = () => audioRef.current?.play().catch(() => {});
    // Button semantics (not role="img") so keyboard users can focus and activate it — Enter/Space play
    // the sound just like a click.
    return (
        <div
            className={classes.nedry}
            role="button"
            tabIndex={0}
            aria-label="Play the Nedry sound: ah ah ah, you didn't say the magic word!"
            title="Ah ah ah! You didn't say the magic word!"
            onClick={play}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    play();
                }
            }}
        >
            <img className={classes.body} src={body} alt="" />
            <img className={classes.head} src={head} alt="" />
            <img className={classes.hand} src={hand} alt="" />
            <audio ref={audioRef} src={ahahah} preload="auto" />
        </div>
    );
}
